import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import CardImage1 from "images/png/landing-page/professional-tools/card1.png";
import CardImage2 from "images/png/landing-page/professional-tools/card2.png";
import CardImage3 from "images/png/landing-page/professional-tools/card3.png";
import CardImage4 from "images/png/landing-page/professional-tools/card4.png";
import SpotifyCanvasTool from "./spotifyCanvas";

const ProfessionalTools = () => {
  return (
    <Container>
      <Typography
        align="center"
        size="4.8rem"
        m_size="2.8rem"
        weight="bold"
        mb="2"
        m_mb="1.2"
        dataAos="fade-up"
      >
        Professional Tools
      </Typography>
      <Typography
        align="center"
        size="xl"
        m_size="m"
        color={Colors.grey400}
        mb="6.4"
        dataAos="fade-up"
      >
        Get Access To High Quality Tools That Helps You To Manage Your Music
        Career
      </Typography>
      <Grid data-aos="fade-up">
        <Card>
          <CardImg src={CardImage1} alt="rated-tube" width="80%" />
          <CardText>
            <InlineFlex>
              <Typography size="2xl" weight="semibold">
                Rated
              </Typography>
              <Typography size="2xl" weight="semibold" color={Colors.yellow500}>
                Tube
              </Typography>
            </InlineFlex>
            <Typography size="lg" color={Colors.grey500}>
              Get your music videos featured on top platforms like Apple Music,
              Vevo, and Tidal. Keep 100% of your earnings.
            </Typography>
          </CardText>
        </Card>
        <Card>
          <CardImg src={CardImage2} alt="rated afrika playlist" width="100%" />
          <CardText>
            <Typography size="2xl" mb="0.8" weight="semibold">
              Rated Afrika Playlist
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              Submit your music for a chance to be featured on our exclusive
              Rated Afrika playlist.
            </Typography>
          </CardText>
        </Card>
      </Grid>
      <Grid two="true" data-aos="fade-up">
        <Card>
          <CardImg src={CardImage3} alt="rated-fans" width="100%" />
          <CardText>
            <InlineFlex>
              <Typography size="2xl" weight="semibold">
                R
              </Typography>
              <Typography color="#FF0050" size="2xl" weight="semibold">
                A
              </Typography>
              <Typography size="2xl" weight="semibold">
                ted Fans
              </Typography>
            </InlineFlex>
            <Typography size="lg" color={Colors.grey500}>
              Customizable, free landing page designed to showcase your music,
              videos, and social media.
            </Typography>
          </CardText>
        </Card>
        <Card>
          <CardImg src={CardImage4} alt="promo-cards" width="100%" />
          <CardText>
            <Typography size="2xl" mb="0.8" weight="semibold">
              Promo Cards
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              Easily create stunning, high-quality images of your album art for
              free.
            </Typography>
          </CardText>
        </Card>
        <Card>
          <SpotifyCanvasTool />
          <CardText>
            <Typography size="2xl" mb="0.8" weight="semibold">
              Spotify Canvas Generator
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              Enhance your Spotify releases with free, custom canvas animations
              and videos.
            </Typography>
          </CardText>
        </Card>
      </Grid>
    </Container>
  );
};

export default ProfessionalTools;

const Container = styled.div`
  padding: 6.4rem 10.4rem;
  color: white;
  @media only screen and (max-width: 769px) {
    padding: 4rem 2rem;
  }
`;

const Grid = styled.div<{ two?: string }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.two === "true" ? "1fr 1fr 1fr" : "2fr 1fr"};
  column-gap: 0.8rem;
  margin-bottom: 0.8rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    row-gap: 2rem;
  }
`;

const Card = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 1.2rem;
  border: 0.5px solid ${Colors.grey600};
  background-color: #131313;
  display: flex;
  flex-direction: column;
`;

const CardImg = styled.img<{ width: string }>`
  margin-left: auto;
  margin-right: auto;
  width: ${(props) => props.width};
`;

const CardText = styled.div`
  padding: 3.2rem;
  margin-top: auto;
  padding-top: 0;
`;

const InlineFlex = styled.div`
  display: inline-flex;
  margin-bottom: 0.8rem;
`;
